"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.teamSlice = teamSlice;
const lodash_1 = __importDefault(require("lodash"));
const appConstants_1 = require("../../constants/appConstants");
const teamInitialState = {
    team: {
        teamName: '',
        initialTeamName: '',
        teamId: '',
        teams: [],
        state: '',
        team: {
            properties: {
                ENABLE_MULTIUSE: 'true',
                ENABLE_SINGLEUSE: 'true',
                ENABLE_SUBSCRIPTIONS: 'true',
                REQUEST_LIMIT: '',
            },
        },
        features: {},
        properties: {},
        decoratedUser: {},
        teamRequestLimit: '',
        teamProperty: '',
        owners: [],
        hasChanges: false,
        isTeamNameError: false,
        isTeamRequestLimitError: false,
    },
};
function teamSlice(set) {
    return {
        ...teamInitialState,
        setTeam(team) {
            set((state) => {
                state.team.team = team;
                state.team.teamRequestLimit = team?.properties?.[appConstants_1.teamFeaturesConstants.requestLimit] || '';
                return state;
            }, false, '[setTeam]');
        },
        setTeams(teams) {
            set((state) => {
                state.team.teams = teams || [];
                return state;
            }, false, '[setTeams]');
        },
        setTeamOwners(owners) {
            set((state) => {
                state.team.owners = owners;
                return state;
            }, false, '[setTeamOwners]');
        },
        setTeamId(teamId) {
            set((state) => {
                state.team.teamId = teamId;
                return state;
            }, false, '[setTeamId]');
        },
        setTeamName(teamName) {
            set((state) => {
                state.team.teamName = teamName;
                return state;
            }, false, '[setTeamName]');
        },
        setInitialTeamName(initialTeamName) {
            set((state) => {
                state.team.initialTeamName = initialTeamName;
                return state;
            }, false, '[setInitialTeamName]');
        },
        setIsTeamNameError(isTeamNameError) {
            set((state) => {
                state.team.isTeamNameError = isTeamNameError;
                return state;
            }, false, '[setIsTeamNameError]');
        },
        setTeamProperty(properties) {
            set((state) => {
                state.team.teams =
                    state.team.teams && state.team.teams.length > 0
                        ? state.team.teams.map(teamData => {
                            if (lodash_1.default.isEqual(teamData.id, properties?.teamId)) {
                                teamData.properties[properties?.propertyKey] = properties?.propertyValue;
                            }
                            return teamData;
                        })
                        : [];
                return state;
            }, false, '[setTeams]');
        },
        setSelectedTeamProperty(teamProperty) {
            set((state) => {
                state.team.teamProperty = teamProperty;
                return state;
            }, false, '[setSelectedTeamProperty]');
        },
        setTeamRequestLimit(teamRequestLimit) {
            set((state) => {
                state.team.teamRequestLimit = teamRequestLimit;
                return state;
            }, false, '[setTeamRequestLimit]');
        },
        setIsTeamRequestLimitError(isTeamRequestLimitError) {
            set((state) => {
                state.team.isTeamRequestLimitError = isTeamRequestLimitError;
                return state;
            }, false, '[setIsTeamRequestLimitError]');
        },
        setHasChanges(hasChanges) {
            set((state) => {
                state.team.hasChanges = hasChanges;
                return state;
            }, false, '[setHasChanges]');
        },
        setDecoratedUser(decoratedUser) {
            set((state) => {
                state.team.decoratedUser = decoratedUser;
                return state;
            }, false, '[setDecoratedUser]');
        },
    };
}
